export default class StoreEngine  {
    // field
    private menuObject: any;
    private states = ['success', 'warning', 'required'];

    // constructor
    constructor(menuObject: any) {
        this.menuObject = menuObject;
    }

    // function
    public setCharacteristicState(
            characteristicId: number, settingKey: string, property: string, value: boolean): any {


        const propertyIndex: number = this.states.indexOf(property);
        this.states.splice(propertyIndex, 1);

        this.menuObject.filter((item: any) => item.id === characteristicId)[0]
            .characteristicsItems.filter((next: any) => next.characteristicName === settingKey)[0][property] = value;

        this.states.forEach((element) => {
            this.menuObject.filter((item: any) => item.id === characteristicId)[0]
            .characteristicsItems.filter((next: any) => next.characteristicName === settingKey)[0][element] = false;
        });

        // Check for mainNav status
        let menuItemSucceed: boolean = true;
        const items: any = this.menuObject.filter((item: any) => item.id === characteristicId)[0].characteristicsItems;


        for (const iterator of items) {
            if (iterator.success === false) {
                menuItemSucceed = false;
                break;
            }
        }

        this.menuObject.filter((item: any)  => item.id === characteristicId)[0].success = menuItemSucceed;

        return this.menuObject;
    }
}
